export const AUTH_ONBOARDING_RESUME_KEY = 'pn_auth_onboarding_resume';